import type { ImMNElement } from '../../../common/elements/elementModelTypes';
import { getLabels } from '../../../common/elements/utils/elementPropertyUtils';
import { getTaskListLabelIds } from '../../../common/taskLists/taskListLabelUtils';
import { isSingleEditorTaskList } from '../../../common/taskLists/taskListContentVersionUtils';
import type { TiptapContent } from '../../../common/tiptap/tiptapTypes';
import { isEmpty } from '../../../common/utils/immutableHelper';

/**
 * Determines the changes to be persisted for a task list element update.
 * - If the task list is a legacy task list then only the textContent is persisted
 * - If it's a new single-editor task list:
 *     - We also need to save the labels that are referenced by the task items in the textContent
 *     - This is so the element can be kept in sync with the labels within its content, and
 *     - All other element labels functionality will behave the same as it does for other elements
 *
 * NOTE: A list referencing no labels sends none, so the element never stores an empty array
 * - Otherwise, an empty array will satisfy the "labelsBySection" index and add the element to it, for no value
 * - If it used to have labels and now has none, the element will be updated to remove the labels field entirely
 */
export const getTaskListUpdateChanges = (
    element: ImMNElement,
    textContent: TiptapContent,
): { textContent: TiptapContent; labels?: string[] } => {
    if (!isSingleEditorTaskList(element)) return { textContent };

    const labels = getTaskListLabelIds(textContent);
    if (isEmpty(labels) && isEmpty(getLabels(element))) return { textContent };

    return { textContent, labels };
};
